import { createCommand } from '@commander-js/extra-typings';
import type { GetRootCommandFn } from '@wix/cli-command-contract';
import { devCommand } from './dev.js';

export const getRootCommand: GetRootCommandFn = async function getRootCommand(
  services,
  cliVersion
) {
  return createCommand('site').addCommand(devCommand(services, cliVersion));
};
